import { FooterContainer, FooterContent } from "./Authentication.styles";
import BonisoftLogo from "../../common/ui/BonisoftLogo";
import { useTranslation } from "react-i18next";

export default function AuthFooter() {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    const address = "Hinterm Fleer 42, 49757 Werlte";
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

    return (
        <FooterContainer>
            <FooterContent>
                <a href="mailto:info@bonisoft.de">info@bonisoft.de</a>
                <span className="separator">|</span>
                <a href="https://bonisoft.de/privacy-policy/">{t("footer.privacy")}</a>
                <span className="separator">|</span>
                <a href="https://bonisoft.de/impressum/">{t("footer.impressum")}</a>
                <span className="separator">|</span>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}>
                    <BonisoftLogo imgRatio={1.2} />
                    Bonisoft © {currentYear}
                </span>
                <span className="separator">|</span>
                <a href={mapsUrl} target="_blank" rel="noopener noreferrer">
                    {address}
                </a>
            </FooterContent>
        </FooterContainer>
    );
}